<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            type="text"
            label="Name"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.account"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            type="text"
            label="License No"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.name"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            type="text"
            label="SSN"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.idNo"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-text-field
            type="text"
            label="Email"
            dense
            clearable
            class="font-weight-normal"
            v-model="queryObject.nationality"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'每頁筆數' }"
            class="elevation-1"
            widths="1500"
            no-data-text="無資料"
            loading-text="資料傳輸中"
            hide-default-footer
            multi-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>
                  <v-row class="pa-3 ma-3" align="center" justify="center">
                    <span style="color:#239e46;">Total {{items.length}} , Page Size</span>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn dark text color="#239e46" class="ml-2" v-on="on">
                          {{ itemsPerPage }}
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(number, index) in itemsPerPageArray"
                          :key="index"
                          @click="updateItemsPerPage(number)"
                        >
                          <v-list-item-title>{{ number }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <!-- <v-btn color="#239e46" style="color:white;" class="pa-1 ml-1 mb-1">ADD</v-btn> -->
              </v-toolbar>
            </template>
            <template v-slot:item.status="{ item }">{{getColor(item.status)}}</template>
            <template v-slot:item.type="{ item }">{{getColor(item.type)}}</template>
            <template v-slot:item.gender="{ item }">{{getColor(item.gender)}}</template>
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
              <v-icon @click="deleteItem(item)">delete</v-icon>
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination
                  color="red"
                  v-model="currentPage"
                  :length="maxPage"
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  data() {
    return {
      valid: false,
      loading: false,
      options: {},

      items: this.getFakeModel("driver"),
      queryObject: {},
      queryPager: {
        pageSize: 5,
        currentPage: 1,
        sortColumnNameList: []
      },
      itemsPerPageArray: [5, 10, 30, 50],
      currentPage: 1,
      itemsPerPage: 5,
      maxPage: 0,
      pageSize: 10,
      totalCount: 0,
      criterion: {},
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
      headers: [
        { text: "Name", value: "motorAccountName", width: 100 },
        { text: "License No", value: "licenseNo", width: 100 },
        { text: "Driver Class", value: "driverClass", width: 100 },
        { text: "SSN", value: "ssn", width: 100 },
        { text: "Gender", value: "gender", width: 100 },
        { text: "Email", value: "email", width: 100 },
        { text: "Address", value: "address", width: 100 }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getInterpreterFromServer();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    getColor(value) {
      if (value == "AAA") {
        return "需求單位";
      } else if (value == "BBB") {
        return "培訓單位";
      } else if (value == "CCC") {
        return "通譯人員";
      } else if (value == "Y") {
        return "啟用";
      } else if (value == "N") {
        return "停用";
      } else if (value == "W") {
        return "待審核";
      } else if (value == "F") {
        return "Female";
      } else if (value == "M") {
        return "Man";
      } else {
        return value;
      }
    },
    addItem() {
      this.$router.push({
        path: "/ListInterpreterEdit/init"
      });
    },
    editItem(item) {
      this.$router.push({
        path: "/ListInterpreterEdit/" + item.uuid
      });
    },
    deleteItem(item) {
      if (confirm("確定要刪除帳號" + item.account + "嗎?")) {
        console.log("delete Item " + item.uuid);
        var vm = this;
        vm.axios
          .delete(vm.idbServerUrl + "idb/member/memberAccount/" + item.uuid, {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          })
          .then(function(response) {
            console.log("response " + JSON.stringify(response));
            vm.delSuccessSwalUtil();
            vm.getInterpreterFromServer();
          })
          .catch(function(error) {
            vm.handErrorUtil(error.response.status);
            //console.log("!!!! " + error);
          });
      } else {
        console.log("delete canceled" + item.uuid);
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.getInterpreterFromServer();
    },

    getInterpreterFromServer() {
      var vm = this;

      // const { sortBy, sortDesc } = this.options

      // var sortColumnNameList = ["-lastModifyDate"]
      // sortBy.forEach((element, index) => {
      //   sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
      // });

      // var queryObjectStr = JSON.stringify(vm.queryObject)

      // var queryPagerStr = JSON.stringify({
      //   pageSize: vm.itemsPerPage,
      //   currentPage: vm.currentPage,
      //   sortColumnNameList: sortColumnNameList
      // });
      // var criterionStr = JSON.stringify({
      //     equal: [{propertyName: "type", value: "CCC"},
      //     {propertyName: "mainDeptId", value: vm.userProfile.memberAccount.mainDeptId}]
      // });

      // if ( vm.userProfile.memberAccount.type == "AAA" && vm.userProfile.sysAdmin ) {
      //   criterionStr = JSON.stringify({
      //     equal: [{propertyName: "type", value: "CCC"}]
      //   });
      // }
      // vm.axios
      //   .get(
      //     vm.idbServerUrl +
      //       "idb/member/memberAccount?queryString=" +
      //       encodeURIComponent(queryObjectStr) +
      //       "&queryPager=" +
      //       encodeURIComponent(queryPagerStr) +
      //       "&criterion=" +
      //       encodeURIComponent(criterionStr),
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: vm.$localStorage.get("idb_login_token")
      //       }
      //     }
      //   )
      //   .then(function(response) {
      //     //var dataResponse = JSON.stringify(response.data.resultList)
      //     console.log("Result \n" +JSON.stringify(response.data.resultList))
      //     vm.currentPage = response.data.currentPage;
      //     vm.maxPage = response.data.maxPage;
      //     vm.pageSize = response.data.pageSize;
      //     vm.totalCount = response.data.totalCount;
      //     vm.items = response.data.resultList;

      //     for (var i = 0; i < vm.items.length; i++) {
      //       if (vm.items[i].creatorName === "user") {
      //         vm.items[i].mainDeptName = "個人申請";
      //       }
      //     }
      //   })
      //   .catch(function(error) {
      //     vm.handErrorUtil(error);
      //     //console.log(error);
      //   });
    }
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
  }
};
</script>




